import { useMemo } from "react";
import LineChart from "src/components/ScoringChart/Line/LineChart";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import { tokenHistoryTitles } from "src/config/constants";
import useYAxisConfig from "src/hooks/useYAxisConfig";
import { numberWithCommas, toFixed } from "src/services/utils";

const getOption = (yAxisConfig) => {
  return {
    chart: {
      height: 280,
    },
    xAxis: {
      type: "datetime",
    },
    ...beautifulTooltip((value) => numberWithCommas(toFixed(value, 3))),
    yAxis: yAxisConfig,
    legend: {
      enabled: true,
    },
  };
};

export default function DetailTokenChart({ historyData, typeList }) {
  const series = useMemo(() => {
    let result = [];

    if (historyData) {
      let index = 0;
      for (var _type of typeList) {
        result.push({
          name: tokenHistoryTitles[_type],
          data: historyData[_type],
          type: "line",
          yAxis: index,
        });
        index++;
      }
    }
    return result;
  }, [historyData, typeList]);

  const yAxisConfig = useYAxisConfig(
    series,
    (item) => item["data"],
    (item) => item[1],
    [
      { title: { text: tokenHistoryTitles[typeList[0]] } },
      { title: { text: tokenHistoryTitles[typeList[1]] }, opposite: true },
    ]
  );

  return <LineChart series={series} option={getOption(yAxisConfig)} />;
}
